import {
  FETCH_FILE,
  FETCH_FILE_FAILED,
  FETCH_FILE_SUCCESS,
  FETCH_DATA_RESET,
  FETCH_DATA_NOTIFIED,
} from "../action/actionType";

const initialState = {
  loading: false,
  data: null,
  error: null,
  notified: false,
};

const fetchReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_FILE:
      return {
        ...state,
        loading: true,
      };
    case FETCH_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
        notified: false,
      };
    case FETCH_FILE_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: payload,
        notified: false,
      };
    case FETCH_DATA_RESET:
      return {
        ...state,
        loading: false,
        data: null,
        error: null,
        notified: false,
      };
    case FETCH_DATA_NOTIFIED:
      return {
        ...state,
        notified: true,
      };
    default:
      return state;
  }
};

export default fetchReducer;
